import { ids } from '../ids.ts'
import XweatherLogo from './svg/xweatherLogo.svg'

export const SplashScreen = () => (
	<div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} data-ta={ids.common.loading}>
		<img style={{ height: 200, maxWidth: '50%' }} src={XweatherLogo} alt='Xweather' />
	</div>
)
